module.exports = __webpack_public_path__ + "static/media/tanks.3e3a8158.png";